/**
 * Generic modal
 * @method setAlertModal
 * @method setLoadingModal
 * @method setConfirmModal
 * @method setSuccessModal
 * Authen modal
 * @method setOtpModal
 * Redeem modal
 * @method setConfirmRedeemModal
 * @method setDrawDeliveryModal
 * @method setSerialModal
 * @method setShippingAddressModal
 * @method setSkipModal
 * @method setFreeDeliverySuccessModal
 * @method setConfirmDeliveryAddressModal
 * Other modal
 * @method setWelcomePointModal
 * @method setPointCollectionModal
 * @method setMissionSuccessModal
 * @method setMissionSuccessCheckinModal
 * @method setCancelMemberModal
 * @method setMarketingModal
 * @method setPrivacySettingModal
 * @method setTermsRegisterModal
 * @method setPrivacyRegisterModal
 * @method setAgeConsentAlertModal
 * @method setMarketingReConsentModal
 * @method setTermsReConsentModal
 * @method setPrivacyReConsentModal
 * @method setLeaderBoardConditionModal
 * @method setWelcomeCouponModal
 */
export function ModalController () {
    //#region generic
    this.alertModal = null;
    this.loadingModal = null;
    this.confirmModal = null;
    this.successModal = null;

    this.setAlertModal = function(alertModalController) {
        this.alertModal = alertModalController;
    };

    this.setLoadingModal = function(loadingModalController) {
        this.loadingModal = loadingModalController;
    };

    this.setConfirmModal = function(confirmModalController) {
        this.confirmModal = confirmModalController;
    };

    this.setSuccessModal = function(successModalController) {
        this.successModal = successModalController;
    };
    //#endregion generic

    //#region authen
    this.otpModal = null;
    this.setOtpModal = function(otpModalController) {
        this.otpModal = otpModalController;
    };
    //#endregion authen

    //#region redeem
    this.confirmRedeemModal = null;
    this.drawDeliveryModal = null;
    this.donateSuccessModal = null;
    this.serialModal = null;
    this.shippingAddressModal = null;
    this.freeDeliverySuccessModal = null;
    this.confirmDeliveryAddressModal = null;

    this.setConfirmRedeemModal = function (confirmRedeemModal) {
        this.confirmRedeemModal = confirmRedeemModal;
    };

    this.setDrawDeliveryModal = function (drawDeliveryModal) {
        this.drawDeliveryModal = drawDeliveryModal;
    };

    this.setDonateSuccessModal = function (donateSuccessModal) {
        this.donateSuccessModal = donateSuccessModal;
    };

    this.setSerialModal = function (serialModal) {
        this.serialModal = serialModal;
    };

    this.setShippingAddressModal = function (shippingAddressModal) {
        this.shippingAddressModal = shippingAddressModal;
    };
    this.setFreeDeliverySuccessModal = function(freeDeliverySuccessModal){
        this.freeDeliverySuccessModal = freeDeliverySuccessModal;
    };
    this.setConfirmDeliveryAddressModal = function(confirmDeliveryAddressModal){
        this.confirmDeliveryAddressModal = confirmDeliveryAddressModal;
    }
    //#endregion redeem

    //#region custom modal
    this.productDescriptionModal = null;
    this.pointSummaryModal = null;
    this.sktpModal = null;
    this.pointCollectionStepModal = null;
    this.welcomePointModal = null;
    this.pointCollectionModal = null;
    this.alertRegisterModal = null;
    this.termModal = null;
    this.missionSuccessModal = null;
    this.missionSuccessCheckinModal = null;
    this.cancelMemberModal = null;
    this.marketingModal = null;
    this.privacySettingModal = null;
    this.copyPersonalModal = null;
    this.termsRegisterModal = null;
    this.privacyRegisterModal = null;
    this.ageConsentAlertModal = null;
    this.marketingReConsentModal = null;
    this.termsReConsentModal = null;
    this.privacyReConsentModal = null;
    this.leaderBoardConditionModal = null;
    this.welconeCouponModal = null;

    this.setProductDescriptionModal = function (controller) {
        this.productDescriptionModal = controller;
    };
    this.setPointSummaryModal = function (controller) {
        this.pointSummaryModal = controller;
    };
    this.setSkipModal = function (sktpModal) {
        this.skipModal = sktpModal;
    };
    this.setPointCollectionStepModal = function (pointCollectionStepModal) {
        this.pointCollectionStepModal = pointCollectionStepModal;
    };
    this.setWelcomeCouponModal = function (welcomeCouponModal) {
        this.welcomeCouponModal = welcomeCouponModal;
    };
    this.setWelcomePointModal = function (welcomePointModal) {
        this.welcomePointModal = welcomePointModal;
    };
    this.setPointCollectionModal = function (pointCollectionModal) {
        this.pointCollectionModal = pointCollectionModal;
    };
    this.setAlertRegisterModal = function(alertRegisterModalController) {
        this.alertRegisterModal = alertRegisterModalController;
    };
    this.setTermModal = function(termModalController) {
        this.termModal = termModalController;
    };
    this.setMissionSuccessModal = function (missionSuccessModal) {
        this.missionSuccessModal = missionSuccessModal;
    };
    this.setMissionSuccessCheckinModal = function (missionSuccessCheckinModal) {
        this.missionSuccessCheckinModal = missionSuccessCheckinModal;
    };
    this.setCancelMemberModal = function (cancelMemberModal) {
        this.cancelMemberModal = cancelMemberModal;
    };
    this.setMarketingModal = function (marketingModal) {
        this.marketingModal = marketingModal;
    };
    this.setPrivacySettingModal = function (privacySettingModal) {
        this.privacySettingModal = privacySettingModal;
    };
    this.setCopyPersonalModal = function (copyPersonalModal) {
        this.copyPersonalModal = copyPersonalModal;
    };
    this.setTermsRegisterModal = function(termsRegisterModalController) {
        this.termsRegisterModal = termsRegisterModalController;
    };
    this.setPrivacyRegisterModal = function(privacyRegisterModalController) {
        this.privacyRegisterModal = privacyRegisterModalController;
    };
    this.setAgeConsentAlertModal = function(ageConsentAlertModalController) {
        this.ageConsentAlertModal = ageConsentAlertModalController;
    };
    this.setMarketingReConsentModal = function(MarketingReConsentModalController) {
        this.marketingReConsentModal = MarketingReConsentModalController;
    };
    this.setTermsReConsentModal = function(TermsReConsentModalController) {
        this.termsReConsentModal = TermsReConsentModalController;
    };
    this.setPrivacyReConsentModal = function(PrivacyReConsentModalController) {
        this.privacyReConsentModal = PrivacyReConsentModalController;
    };
    this.setLeaderBoardConditionModal = function(LeaderBoardConditionModalController) {
        this.leaderBoardConditionModal = LeaderBoardConditionModalController;
    };
    
    //#endregion custom modal
}
